import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Renders every route from its default position.
 *
 * The browser keeps the previous page's scroll offset when the next route
 * mounts, so a list opened after a scrolled page appears already scrolled with
 * its header behind the sticky app bar. Only a real route change resets the
 * position: navigations that stay on the same path (list pagination, search,
 * re-navigating with new state) keep the user where they are.
 */
export const useScrollToTopOnNavigate = () => {
  const { pathname } = useLocation();
  const lastPathnameRef = useRef<string | null>(null);

  useEffect(() => {
    if (lastPathnameRef.current === pathname) return;
    lastPathnameRef.current = pathname;

    if (typeof window.scrollTo === "function") window.scrollTo({ top: 0, left: 0 });
  }, [pathname]);
};
